module.exports = __webpack_public_path__ + "img/scepter-off.bd656393.png";